import { reportsConstants } from 'locale/team'
import EditProfileCard from '../../../../../../components/forms/screens/TeamMemberEditFormV2/EditProfileCard'
import ProfileFieldRow from './ProfileFieldRow'

type Props = { profile: Record<string, any>; t: (k: string) => string }

const EmergencyContactViewCard = ({ profile, t }: Props) => {
  const name = profile.emergencyContactName?.first
    ? `${profile.emergencyContactName.first} ${profile.emergencyContactName.last || ''}`.trim()
    : ''
  return (
    <EditProfileCard
      title={t(reportsConstants.PROFILE_VIEW_CARD_EMERGENCY)}
      testId="profile-view-emergency"
      showTitleDivider
      fullWidth
    >
      <ProfileFieldRow
        label={t(reportsConstants.PROFILE_VIEW_EMERGENCY_NAME)}
        value={name}
      />
      <ProfileFieldRow
        label={t(reportsConstants.PROFILE_VIEW_EMERGENCY_RELATION)}
        value={profile.emergencyContactRelation}
      />
      <ProfileFieldRow
        label={t(reportsConstants.PROFILE_VIEW_EMERGENCY_NUMBER)}
        value={profile.emergencyContactNumber}
      />
    </EditProfileCard>
  )
}

export default EmergencyContactViewCard
